import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const SuccessStories = () => {
  const [activeIndustry, setActiveIndustry] = useState('all');

  const industries = [
  { id: 'all', label: 'Все отрасли', icon: 'Grid' },
  { id: 'beauty', label: 'Красота', icon: 'Sparkles' },
  { id: 'realestate', label: 'Недвижимость', icon: 'Home' },
  { id: 'delivery', label: 'Доставка', icon: 'Truck' },
  { id: 'retail', label: 'Ритейл', icon: 'ShoppingBag' }];


  const stories = [
  {
    id: 1,
    industry: 'beauty',
    company: "Beauty Studio Almaty",
    logo: "/images/success_logo_1.webp",
    logoAlt: "Elegant beauty salon interior with modern styling chairs and large mirrors in bright white and gold decor",
    image: "/images/success_logo_1.webp",
    imageAlt: "Luxurious beauty salon interior with professional styling stations, elegant lighting, and modern equipment in sophisticated white and gold color scheme",
    representative: "Айгуль Нурланова",
    position: "Владелец сети салонов",
    avatar: "/images/rocket_gen_img_14d9d1e3f-1763293907442.webp",
    avatarAlt: "Professional Kazakh businesswoman with long dark hair wearing elegant black blazer smiling confidently in modern office setting",
    quote: "Jetu AI помог нам автоматизировать запись клиентов и сократить количество пропущенных звонков на 90%. Теперь наши администраторы могут сосредоточиться на качестве обслуживания.",
    metrics: [
    { label: "Рост записей", value: "+156%", icon: "TrendingUp" },
    { label: "Экономия времени", value: "25 ч/нед", icon: "Clock" },
    { label: "Удовлетво\u00ADренность", value: "98%", icon: "Heart" }]

  },
  {
    id: 2,
    industry: 'realestate',
    company: "Astana Property Group",
    logo: "/images/success_logo_2.webp",
    logoAlt: "Modern luxury apartment building exterior with glass windows and contemporary architecture against blue sky",
    image: "/images/success_image_2.webp",
    imageAlt: "Contemporary high-rise residential building with sleek glass facade and modern architectural design in urban setting with clear blue sky",
    representative: "Марат Жумабаев",
    position: "Директор по продажам",
    avatar: "/images/rocket_gen_img_1ba34aa03-1763294059493.webp",
    avatarAlt: "Professional Kazakh businessman with short dark hair wearing navy blue suit and white shirt smiling in corporate office environment",
    quote: "Платформа позволила нам обрабатывать запросы 24/7 и квалифицировать лиды автоматически. Конверсия выросла в 2 раза, а стоимость привлечения клиента снизилась на 40%.",
    metrics: [
    { label: "Рост конверсии", value: "+200%", icon: "TrendingUp" },
    { label: "Обработка лидов", value: "24/7", icon: "Clock" },
    { label: "Снижение CAC", value: "-40%", icon: "DollarSign" }]

  },
  {
    id: 3,
    industry: 'delivery',
    company: "Express Delivery KZ",
    logo: "/images/success_logo_3.webp",
    logoAlt: "Delivery truck with packages and boxes in organized warehouse with bright lighting and modern logistics setup",
    image: "/images/rocket_gen_img_113881709-1763300800694.webp",
    imageAlt: "Professional delivery service warehouse interior with organized packages, delivery trucks, and efficient logistics operations in bright modern facility",
    representative: "Дина Сагындыкова",
    position: "Операционный директор",
    avatar: "/images/rocket_gen_img_10d60e496-1763295319842.webp",
    avatarAlt: "Professional Kazakh businesswoman with shoulder-length dark hair wearing white blouse smiling warmly in bright modern office space",
    quote: "Автоматизация уведомлений о доставке и обработка запросов клиентов освободила нашу команду для решения сложных задач. Количество повторных обращений сократилось на 75%.",
    metrics: [
    { label: "Сокращение обращений", value: "-75%", icon: "TrendingDown" },
    { label: "Доставок в день", value: "5000+", icon: "Package" },
    { label: "NPS Score", value: "92", icon: "Star" }]

  }];


  const filteredStories = activeIndustry === 'all' ?
  stories :
  stories?.filter((story) => story?.industry === activeIndustry);

  return (
    <section className="py-16 lg:py-24 bg-gradient-to-b from-[#0A0E27] to-[#0F172A]">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center space-x-2 bg-[#1E293B] rounded-full px-6 py-3 mb-6">
              <Icon name="Award" size={20} color="#00D4FF" />
              <span className="text-sm font-medium text-[#00D4FF]">
                Истории успеха
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-headline font-bold text-white mb-4">
              Реальные результаты
              <br />
              <span className="bg-gradient-to-r from-[#00D4FF] to-[#9D4EDD] bg-clip-text text-transparent">
                реальных компаний
              </span>
            </h2>
            <p className="text-lg text-gray-300 max-w-3xl mx-auto">
              Узнайте, как бизнесы в Казахстане трансформируют свои операции с помощью Jetu AI
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {industries?.map((industry) =>
            <button
              key={industry?.id}
              onClick={() => setActiveIndustry(industry?.id)}
              className={`px-6 py-3 rounded-xl font-medium transition-all duration-300 flex items-center space-x-2 ${
              activeIndustry === industry?.id ?
              'bg-gradient-to-r from-[#00D4FF] to-[#9D4EDD] text-white shadow-lg' :
              'bg-white/5 backdrop-blur-sm text-gray-300 border border-white/10 hover:border-[#00D4FF]/50'}`
              }>

                <Icon name={industry?.icon} size={18} />
                <span>{industry?.label}</span>
              </button>
            )}
          </div>

          <div className="space-y-8">
            {filteredStories?.map((story, index) =>
            <div
              key={story?.id}
              className="bg-white/5 backdrop-blur-sm rounded-3xl overflow-hidden border border-white/10 hover:border-[#00D4FF]/50 transition-all duration-300"
              style={{ animationDelay: `${index * 100}ms` }}>

                <div className="grid lg:grid-cols-2 gap-0">
                  <div className="relative h-64 lg:h-auto overflow-hidden">
                    <Image
                    src={story?.image}
                    alt={story?.imageAlt}
                    className="w-full h-full object-cover" />

                    <div className="absolute inset-0 bg-gradient-to-t from-[#0A0E27] to-transparent" />
                  </div>

                  <div className="p-8 lg:p-12">
                    <div className="flex items-center space-x-4 mb-6">
                      <div className="w-16 h-16 bg-white rounded-xl flex items-center justify-center overflow-hidden">
                        <Image
                        src={story?.logo}
                        alt={story?.logoAlt}
                        className="w-full h-full object-cover" />

                      </div>
                      <div>
                        <h3 className="text-xl font-semibold text-white">
                          {story?.company}
                        </h3>
                        <p className="text-gray-400 text-sm">
                          {industries?.find((i) => i?.id === story?.industry)?.label}
                        </p>
                      </div>
                    </div>

                    <blockquote className="text-gray-300 text-lg leading-relaxed mb-6 italic">
                      "{story?.quote}"
                    </blockquote>

                    <div className="flex items-center space-x-3 mb-8">
                      <Image
                      src={story?.avatar}
                      alt={story?.avatarAlt}
                      className="w-12 h-12 rounded-full object-cover" />

                      <div>
                        <p className="text-white font-semibold">
                          {story?.representative}
                        </p>
                        <p className="text-gray-400 text-sm">
                          {story?.position}
                        </p>
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-4">
                      {story?.metrics?.map((metric, idx) => (
                        <div
                          key={idx}
                          className="bg-white/5 rounded-xl p-4 border border-white/10"
                        >
                          <Icon name={metric?.icon} size={24} color="#00D4FF" className="mb-2" />
                          <p className="text-2xl font-bold text-white mb-1">
                            {metric?.value}
                          </p>
                          <p 
                            lang="ru"
                            className="text-gray-400 text-[10px] sm:text-xs leading-tight break-words hyphens-auto"
                            style={{ hyphens: 'auto', WebkitHyphens: 'auto' }}
                          >
                            {metric?.label}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="mt-12 text-center">
            <button
              onClick={() => window.location.href = '/contact-support'}
              className="px-8 py-4 bg-gradient-to-r from-[#00D4FF] to-[#9D4EDD] text-white font-semibold rounded-xl hover:shadow-xl transition-all duration-300 hover:scale-105 inline-flex items-center space-x-2">

              <span>Стать следующей историей успеха</span>
              <Icon name="ArrowRight" size={20} />
            </button>
          </div>
        </div>
      </div>
    </section>);

};

export default SuccessStories;